<template>
    <el-container class="h-100 autodamage">
        <sidenav></sidenav>
        <el-container>
            <el-header height="70px" class="app-header">
                <el-row type="flex" :justify="'space-between'" class="h-100">
                    <div v-if="$client.width <= 900" class="sidenav-toggle">
                        <el-button
                            type="text"
                            size="mini"
                            class="p-5px toggle-btn"
                            @click="
                                $store.commit('sideNavCollapsed', !$store.getters.sideNavCollapsed)
                            "
                        >
                            <i
                                :class="[
                                    'fa',
                                    {
                                        'fa-bars': $store.getters.sideNavCollapsed,
                                        'fa-times': !$store.getters.sideNavCollapsed,
                                    },
                                ]"
                            ></i>
                        </el-button>
                    </div>
                    <div>
                        <div v-if="$client.width > 900" class="sidenav-toggle pull-left mr-10px">
                            <el-button
                                type="text"
                                size="mini"
                                class="p-5px toggle-btn"
                                @click="
                                    $store.commit('sideNavHidden', !$store.getters.sideNavHidden)
                                "
                            >
                                <i class="fa fa-bars"></i>
                            </el-button>
                        </div>
                        <el-breadcrumb
                            separator-class="el-icon-arrow-right"
                            :class="$client.width > 900 ? 'pull-left' : null"
                        >
                            <el-breadcrumb-item
                                v-for="item in breadCrumbData"
                                :to="item.to"
                                :key="item.guid"
                            >
                                {{ item.title }}
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-row>
            </el-header>
            <el-main class="position-relative" ref="mainContent">
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import sidenav from '../components/autodamage/sidenav.vue';

export default {
    name: 'autodamage',
    components: { sidenav },
    data() {
        return {
            searchKey: null,
        };
    },
    mounted() {
        this.$store.commit('mainContent', this.$refs.mainContent);
    },
    computed: {
        breadCrumbData() {
            const route = this.$route;
            const data = [];
            const hasParent = route.meta.parent;
            const { title } = route.meta;

            if (hasParent) {
                data.push({
                    title: route.meta.parent.title,
                    to: route.meta.parent.to,
                });
            }

            data.push({
                title,
            });

            return data;
        },
    },
};
</script>

<style lang="scss">
.autodamage {
    .app-header {
        background: #2b2f34;
    }
}
</style>
